import React from "react";

import { Controller } from "react-hook-form";

interface ITextAreaField {
    control: any;
    name: string;
    placeholder: string;
}
const TextAreaField = ({ control, name, placeholder }: ITextAreaField) => {
    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState }) =>
                <div className="textarea">
                    <textarea placeholder={placeholder} {...field}
                        className={ fieldState.error ? "error" : "" } />
                </div>}
        />
    );
};

export default TextAreaField;
